import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartArea, faChartLine, faFishFins, faList, faPersonArrowUpFromLine, faPersonDotsFromLine, faQuestionCircle, faSquarePersonConfined, faTools } from '@fortawesome/free-solid-svg-icons';
import './SigmaStudio.css';
import sigmastudioimage from '../../assets/pageimages/SigmaStudio.webp';

function SigmaStudioHome() {

  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-r from-blue-500 via-purple-500 to-red-500 p-6 flex flex-col items-center">
        <h2 className="text-3xl font-bold text-white mb-6">SigmaStudio</h2>
        
        <div className="mb-6">
          <img 
            id="sigmastudio-id" 
            src={sigmastudioimage} 
            alt="SigmaStudio Image" 
            className="w-1/3 mx-auto object-cover rounded-lg shadow-lg"
          />
        </div>

        <div className="w-full max-w-8xl bg-gray-800 rounded-lg shadow-lg p-6">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
            <Link 
              to="/sigmastudio-variations" 
              className="flex items-center justify-center p-4 bg-gray-600 rounded-lg text-white hover:bg-gray-700 transition"
            >
              <FontAwesomeIcon icon={faList} className="mr-2" />
              My Variations
            </Link>
            <Link 
              to="/sigmastudio-calculators" 
              className="flex items-center justify-center p-4 bg-gray-600 rounded-lg text-white hover:bg-gray-700 transition"
            >
              <FontAwesomeIcon icon={faTools} className="mr-2" />
              DPMO Calculator
            </Link>
            <Link 
              to="/sigmastudio-sipoc" 
              className="flex items-center justify-center p-4 bg-purple-600 rounded-lg text-white hover:bg-purple-700 transition"
            >
              <FontAwesomeIcon icon={faTools} className="mr-2" />
              SIPOC
            </Link>
            <Link 
              to="/sigmastudio-processcharts" 
              className="flex items-center justify-center p-4 bg-purple-600 rounded-lg text-white hover:bg-purple-700 transition"
            >
              <FontAwesomeIcon icon={faTools} className="mr-2" />
              Process Flow
            </Link>
            <Link 
              to="/sigmastudio-pareto" 
              className="flex items-center justify-center p-4 bg-orange-600 rounded-lg text-white hover:bg-orange-700 transition"
            >
              <FontAwesomeIcon icon={faTools} className="mr-2" />
              Pareto
            </Link>
            <Link 
              to="/fivewhys-analysis-home" 
              className="flex items-center justify-center p-4 bg-green-600 rounded-lg text-white hover:bg-green-700 transition"
            >
              <FontAwesomeIcon icon={faQuestionCircle} className="mr-2" />
              5 Whys
            </Link>       
            <Link 
              to="/fives-home" 
              className="flex items-center justify-center p-4 bg-blue-600 rounded-lg text-white hover:bg-blue-700 transition"
            >
              <FontAwesomeIcon icon={faTools} className="mr-2" />
              5S
            </Link>
            <Link 
              to="/sigmastudio-pokayoke" 
              className="flex items-center justify-center p-4 bg-blue-600 rounded-lg text-white hover:bg-blue-700 transition"
            >
              <FontAwesomeIcon icon={faTools} className="mr-2" />
              PokaYoke
            </Link>
            <Link 
              to="/sigmastudio-kanban" 
              className="flex items-center justify-center p-4 bg-blue-600 rounded-lg text-white hover:bg-blue-700 transition"
            >
              <FontAwesomeIcon icon={faTools} className="mr-2" />
              Kanban
            </Link>
            <Link 
              to="/mykaizen-home" 
              className="flex items-center justify-center p-4 bg-purple-600 rounded-lg text-white hover:bg-purple-700 transition"
            >
              <FontAwesomeIcon icon={faChartLine} className="mr-2" />
              Kaizen
            </Link>
            <Link 
              to="/sigmastudio-controlcharts" 
              className="flex items-center justify-center p-4 bg-purple-600 rounded-lg text-white hover:bg-purple-700 transition"
            >
              <FontAwesomeIcon icon={faChartArea} className="mr-2" />
              Control Charts
            </Link>
            <Link 
              to="/fishbone-home" 
              className="flex items-center justify-center p-4 bg-green-600 rounded-lg text-white hover:bg-green-700 transition"
            >
              <FontAwesomeIcon icon={faFishFins} className="mr-2" />
              Fishbone
            </Link>
            <Link 
              to="/doe" 
              className="flex items-center justify-center p-4 bg-green-600 rounded-lg text-white hover:bg-green-700 transition"
            >
              <FontAwesomeIcon icon={faTools} className="mr-2" />
              DOE
            </Link>
            <Link 
              to="/sigmastudio-rnr" 
              className="flex items-center justify-center p-4 bg-green-600 rounded-lg text-white hover:bg-green-700 transition"
            >
              <FontAwesomeIcon icon={faTools} className="mr-2" />
              R&R
            </Link>
            <Link 
              to="/sigmastudio-matrix" 
              className="flex items-center justify-center p-4 bg-purple-600 rounded-lg text-white hover:bg-purple-700 transition"
            >
              <FontAwesomeIcon icon={faChartArea} className="mr-2" />
              Matrix Charts
            </Link>
            <Link 
              to="/sigmastudio-processraci" 
              className="flex items-center justify-center p-4 bg-yellow-500 rounded-lg text-white hover:bg-yellow-600 transition"
            >
              <FontAwesomeIcon icon={faPersonDotsFromLine} className="mr-2" />
              RACI Matrix
            </Link>
            <Link 
              to="/sigmastudio-kra" 
              className="flex items-center justify-center p-4 bg-yellow-500 rounded-lg text-white hover:bg-yellow-600 transition"
            >
              <FontAwesomeIcon icon={faSquarePersonConfined} className="mr-2" />
              KRAs
            </Link>
            <Link 
              to="/sigmastudio-kpi" 
              className="flex items-center justify-center p-4 bg-yellow-500 rounded-lg text-white hover:bg-yellow-600 transition"
            >
              <FontAwesomeIcon icon={faPersonArrowUpFromLine} className="mr-2" />
              KPIs
            </Link>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default SigmaStudioHome;
